import Actions from '../../odata/actions';

const actions = new Actions('stockItemAlternative', 'stockItemAlternatives');

export default actions;
